import React from 'react';
import styled from 'styled-components';
import { AppLink } from '@finect/tabular-core/AppLink';
import { Link } from 'react-router-dom';
import { iconSizes } from '../../commons/iconSizes';
import { Icon } from './../../Icon';
export var Inner = styled.div.withConfig({
  displayName: "ManagerLabel__Inner",
  componentId: "sc-2h1qzj-0"
})(["display:flex;position:relative;margin:0 0 20px;", " width:", "px;height:", "px;"], function (_ref) {
  var _ref$hide = _ref.hide,
    hide = _ref$hide === void 0 ? false : _ref$hide;
  return hide ? 'visibility: hidden;' : '';
}, function (_ref2) {
  var _ref2$size = _ref2.size,
    size = _ref2$size === void 0 ? 1 : _ref2$size;
  return iconSizes[size];
}, function (_ref3) {
  var _ref3$size = _ref3.size,
    size = _ref3$size === void 0 ? 1 : _ref3$size;
  return iconSizes[size];
});
export var Label = styled.div.withConfig({
  displayName: "ManagerLabel__Label",
  componentId: "sc-2h1qzj-1"
})([""]);
export var LabelLink = styled(AppLink).withConfig({
  displayName: "ManagerLabel__LabelLink",
  componentId: "sc-2h1qzj-2"
})([""]);
export var ManagerLabel = function ManagerLabel(_ref4) {
  var manager = _ref4.manager,
    _ref4$lazyLoad = _ref4.lazyLoad,
    lazyLoad = _ref4$lazyLoad === void 0 ? false : _ref4$lazyLoad,
    isPartner = _ref4.isPartner;
  if (!manager) return React.createElement(Inner, {
    hide: true,
    size: 1
  });
  var withLink = manager && manager.features.blog;
  var Component = withLink ? LabelLink : Label;
  var managerLinkProps = withLink ? isPartner ? {
    title: manager.displayName,
    as: 'a',
    href: "https://www.finect.com/grupos/".concat(manager.alias)
  } : {
    title: manager.displayName,
    as: Link,
    to: "/grupos/".concat(manager.alias)
  } : {};
  return React.createElement(Inner, null, React.createElement(Component, managerLinkProps, React.createElement(Icon, {
    size: 1,
    type: "organization",
    alt: manager.displayName,
    image: "https://www.finect.com/image/".concat(manager.icon),
    withBorder: true,
    withMargin: true,
    fill: "#fff",
    lazyLoad: lazyLoad
  })));
};